<template>
  <div class="handle-panel">
    <el-tooltip effect="dark" content="选择历史天气" placement="left">
      <el-popover 
        placement="left"
        width="300"
        v-model="visible"
        trigger="click">
         <div class="block">
            <span style="padding-right:10px">选择时间</span>
            <el-date-picker
              class="handle-panel_date-picker"
              @change="onDateChange"
              align="right"
              v-model="date"
              type="datetime"
              :picker-options="pickerOptions"
              placeholder="选择日期时间"
              default-time="12:00:00">
            </el-date-picker>
            <div class="notify-text">备注: 最早历史数据为2020-07-06</div>
          </div>
        <img slot="reference" src="@/assets/calender.png" alt="历史数据">
      </el-popover>
    </el-tooltip>
    <el-tooltip effect="dark" content="重置当前数据" placement="left">
      <img src="@/assets/repair.png" alt="重置当前数据" @click="repair">
    </el-tooltip>
    <el-tooltip effect="dark" content="刷新最新数据" placement="left">
      <img src="@/assets/touch.png" alt="刷新最新数据" @click="refrsh">
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: "HandlePanel",
  data() {
    return {
      visible: false,
      date: new Date(),
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }],
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    }
  },
  methods: {
    refrsh() {
      this.date = new Date();
      this.$emit('refresh');
    },
    repair() {
      this.$emit('repair');
    },
    onDateChange(date) {
      if (!date) return;
      this.$emit('dateChange', date);
      this.visible = false;
    }
  }
};
</script>

<style lang="less">
.handle-panel {
  color: #fff;
  position: fixed;
  right: 40px;
  top: 20px;
  padding: 20px 8px;
  z-index: 101;
  display: flex;
  flex-direction: column;
  img {
    width: 30px;
    box-shadow: 0px 2px 12px rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.5;
    margin-bottom: 20px;
    &:hover {
      transform: scale(1.2);
    }
  }
}
.notify-text {
  padding-top:10px;
  font-size:12px;
  text-align:right;
  padding-right:20px;
  color: #999;
}
</style>
